import { Routes } from '@angular/router';

import { AuthGuard } from './utils/auth.guard';
import { workspaceSetupGuard } from './utils/workspace-setup.guard';

import { TimeSheetPage } from '@pages';
import { CreateProjectPage, VerifyEmailPage } from '@pages';
import { LoginPage, NotificationsPage, SignupPage } from '@pages';
import { HomePage, DocsPage, ReposPage, UsersPage } from '@pages';
import { ForgotPasswordPage, CreateOrganizationPage } from '@pages';
import { AuditPage, StatsPage, DefinePage, DevopsPage } from '@pages';
import { TicketsPage, BillingPage, QualityPage, CodePage } from '@pages';
import { SettingsPage, DesignPage, DbDesignPage, QuotationsPage, KpisPage } from '@pages';
import { BasePage, ProjectPage, ProfilePage, MarketplacePage, WorkspacePage } from '@pages';
import { TestingPage, CompliancePage, GuardrailsPage, ContactPage } from '@pages';
import { OptimizationPage } from '@pages';
import { LandingPage } from '@pages';
import { WhatsappPage } from '@pages';
import { ArchitecturePage } from '@pages';
import { AuthShellComponent } from './pages/auth/auth-shell/auth-shell.component';

export const routes: Routes = [
  // PUBLIC LANDING
  { path: '', component: LandingPage, pathMatch: 'full' },

  // AUTH (nested for route animations)
  {
    path: '',
    component: AuthShellComponent,
    children: [
      { path: 'login', component: LoginPage, data: { authAnim: 'auth' } },
      { path: 'sign-up', component: SignupPage, data: { authAnim: 'auth' } },
      {
        path: 'verify-email',
        component: VerifyEmailPage,
        data: { authAnim: 'auth', authStep: 1 },
      },
      {
        path: 'create-organization',
        component: CreateOrganizationPage,
        data: { authAnim: 'auth', authStep: 2 },
      },
      {
        path: 'create-project',
        component: CreateProjectPage,
        data: { authAnim: 'auth', authStep: 3 },
      },
      { path: 'forgot-password', component: ForgotPasswordPage, data: { authAnim: 'auth' } },
    ],
  },
  {
    path: '',
    component: BasePage,
    canActivate: [AuthGuard, workspaceSetupGuard],
    children: [
      {
        path: 'home',
        data: { breadcrumb: 'Summary' },
        component: HomePage,
      },
      {
        path: 'workspace',
        data: { breadcrumb: 'Workspace' },
        component: WorkspacePage,
      },
      { path: 'audit', data: { breadcrumb: 'Audit' }, component: AuditPage },
      {
        path: 'billing',
        data: { breadcrumb: 'Project Billing' },
        component: BillingPage,
      },
      {
        path: 'quotations',
        data: { breadcrumb: 'Quotations' },
        component: QuotationsPage,
      },
      {
        path: 'whatsapp',
        data: { breadcrumb: 'Whatsapp' },
        component: WhatsappPage,
      },
      {
        path: 'calls',
        pathMatch: 'full',
        redirectTo: 'whatsapp',
      },
      {
        path: 'testing',
        data: { breadcrumb: 'Automated Testing' },
        component: TestingPage,
      },
      {
        path: 'optimization',
        data: { breadcrumb: 'Optimization' },
        component: OptimizationPage,
      },
      {
        path: 'code',
        data: { breadcrumb: 'Code' },
        component: CodePage,
      },
      {
        path: 'compliance',
        data: { breadcrumb: 'Compliance' },
        component: CompliancePage,
      },
      {
        path: 'define',
        data: { breadcrumb: 'Project Definition' },
        component: DefinePage,
      },
      {
        path: 'architecture',
        data: { breadcrumb: 'Architecture' },
        component: ArchitecturePage,
      },
      {
        path: 'design',
        data: { breadcrumb: 'Project Design' },
        component: DesignPage,
      },
      {
        path: 'db-design',
        data: { breadcrumb: 'DB Design' },
        component: DbDesignPage,
      },
      {
        path: 'devops',
        data: { breadcrumb: 'Dev-Ops' },
        component: DevopsPage,
      },
      { path: 'docs', data: { breadcrumb: 'Documents' }, component: DocsPage },
      {
        path: 'guardrails',
        data: { breadcrumb: 'Guard Rails' },
        component: GuardrailsPage,
      },
      {
        path: 'profile',
        component: ProfilePage,
        data: { breadcrumb: 'User Profile' },
      },
      {
        path: 'project',
        data: { breadcrumb: 'Project' },
        component: ProjectPage,
      },
      {
        path: 'quality',
        data: { breadcrumb: 'Quality' },
        component: QualityPage,
      },
      {
        path: 'repos',
        data: { breadcrumb: 'Repositories' },
        component: ReposPage,
      },
      {
        path: 'stats',
        data: { breadcrumb: 'Project Statistics' },
        component: StatsPage,
      },
      {
        path: 'kpis',
        data: { breadcrumb: 'Kpis' },
        component: KpisPage,
      },
      {
        path: 'marketplace',
        data: { breadcrumb: 'Project Marketplace' },
        component: MarketplacePage,
      },
      {
        path: 'tickets',
        data: { breadcrumb: 'Tickets' },
        component: TicketsPage,
      },
      {
        path: 'users',
        data: { breadcrumb: 'User Management' },
        component: UsersPage,
      },
      {
        path: 'settings',
        data: { breadcrumb: 'Settings' },
        component: SettingsPage,
      },
      {
        path: 'contact',
        data: { breadcrumb: 'Contact' },
        component: ContactPage,
      },
      {
        path: 'notifications',
        data: { breadcrumb: 'Notifications' },
        component: NotificationsPage,
      },
      {
        path: 'time-sheet',
        data: { breadcrumb: 'Time Sheets' },
        component: TimeSheetPage,
      },
    ],
  },
  { path: '**', redirectTo: '/home' },
];
